function loadDingtalk() {
  return import('./export');
}

type DINGTALK_MODULE = Awaited<ReturnType<typeof loadDingtalk>>;

// Only use it within dingtalk runtime, and after loaded, otherwise it will throw error.
export let DingtalkModule: DINGTALK_MODULE;
export async function lazyLoadDingtalk() {
  DingtalkModule = await loadDingtalk();
  return DingtalkModule;
}

export function bindBeforeCreateShareLinkOrSendShareEmail(fn) {
  if (!DingtalkModule) return fn;
  return DingtalkModule.bindBeforeCreateShareLinkOrSendShareEmail(fn);
}
